import ReviewCards from '../components/ReviewCards';
import styles from './StudentReviews.module.css';

export default function StudentReviews() {
    return (
        <section className={styles.StudentReviewsPage} id='admission'>
            <h2 className={styles.PageName}>Testimonials from Our School Family</h2>

            <ReviewCards />
           
        </section>
    )
} 